import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/CSS/Master.css";
import "./assets/CSS/Site.css";
import "./assets/CSS/Timeline.css";
import "./assets/CSS/Projects.css";
import "./assets/CSS/Fonts.css";
import "./assets/CSS/Profile.css";
import "./assets/CSS/M/Master.css";
import "./assets/CSS/M/Site.css";

createApp(App).use(store).use(router).mount("#app");